module.exports = __webpack_public_path__ + "static/media/50gba.0ec1ea5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/50gba.png
// module id = 138
// module chunks = 0